import type { ActiveStatus, WorkflowResp } from '../workflow.types';
import { WorkflowActionModel } from './WorkflowActionModel';
import { WorkflowTriggerModel } from './WorkflowTriggerModel';

export class WorkflowRespModel {
  private readonly _dto: WorkflowResp;
  private readonly _actions: WorkflowActionModel[];
  private readonly _trigger: WorkflowTriggerModel;

  constructor(dto: WorkflowResp) {
    this._dto = dto;
    this._actions = dto.actions?.length ? dto.actions.map(action => new WorkflowActionModel(action)) : [];
    this._trigger = new WorkflowTriggerModel(dto.trigger || {});
  }

  get originDTO(): WorkflowResp {
    return this._dto;
  }

  get actions(): WorkflowActionModel[] {
    return this._actions;
  }

  get id(): string {
    return this._dto.id || '';
  }

  get name(): string {
    return this._dto.name || '';
  }

  get status(): ActiveStatus {
    return this._dto.status || 'INACTIVE';
  }

  get trigger(): WorkflowTriggerModel {
    return this._trigger;
  }

  get triggerJobId(): string {
    return this._dto.triggerJobId || '';
  }
}
